export default "__VITE_ASSET__F$x3AYYU__"